import { combineReducers } from 'redux';
import anomalies from './slices';

const anomalyReducer = combineReducers({
  anomalies,
});

export default anomalyReducer;
